module.exports = __webpack_public_path__ + "img/iDexpress.e9711eee.png";